import { render, staticRenderFns } from "./Noticed.vue?vue&type=template&id=2ca4a0bf"
import script from "./Noticed.vue?vue&type=script&lang=js"
export * from "./Noticed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports